import React from 'react'
import { IoMdAlert } from 'react-icons/io'
import {
    StyledClose,
    StyledErrorContent,
    StyledError,
    StyledErrorModal,
    StyledErrorIcon,
    StyledErrorTitle,
    StyledErrorActions,
} from './styles'

type Props = {
    message: React.ReactNode
    onDismissClick: () => void
    isShown: boolean
}

/**
 * Extract error category from message
 */
function getErrorCategory(message: React.ReactNode): {
    label: string
    type: 'busy' | 'parsing' | 'network' | 'general'
} {
    if (typeof message !== 'string') {
        return { label: 'Error', type: 'general' }
    }

    if (message.includes('Excel is Busy')) {
        return { label: 'Excel Busy', type: 'busy' }
    }
    if (message.includes('Formula Processing Issue')) {
        return { label: 'Formula Error', type: 'parsing' }
    }
    if (message.includes('Connection Issue') || message.includes('Network')) {
        return { label: 'Network Error', type: 'network' }
    }

    return { label: 'Error', type: 'general' }
}

export default function ErrorModal(props: Props) {
    if (!props.isShown) {
        return null
    }

    const category = getErrorCategory(props.message)
    const isString = typeof props.message === 'string'

    return (
        <StyledErrorModal>
            <StyledError>
                <StyledErrorIcon>
                    <IoMdAlert color="#dc3545" size={28} />
                </StyledErrorIcon>

                <StyledErrorTitle>{category.label}</StyledErrorTitle>

                {isString ? (
                    <StyledErrorContent
                        dangerouslySetInnerHTML={{
                            __html: props.message as string,
                        }}
                    />
                ) : (
                    <StyledErrorContent>{props.message}</StyledErrorContent>
                )}

                <StyledErrorActions>
                    <StyledClose onClick={props.onDismissClick}>
                        Dismiss
                    </StyledClose>
                </StyledErrorActions>
            </StyledError>
        </StyledErrorModal>
    )
}
